import { useEffect, useState } from "react";
import { adminListInquiries, adminDeleteInquiry, formatApiErrorDetail } from "@/lib/adminApi";

export default function InquiriesPanel() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");

  const load = async () => {
    try { setRows(await adminListInquiries()); }
    catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (r) => {
    if (!window.confirm(`Delete the inquiry from ${r.name}?`)) return;
    try { await adminDeleteInquiry(r.id); await load(); }
    catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };

  return (
    <section className="admin-subs" data-testid="inquiries-panel">
      <p className="mono-caps admin-hint" data-testid="inquiries-count">{rows.length} shortlist inquir{rows.length === 1 ? "y" : "ies"}</p>
      {error && <p className="admin-error">{error}</p>}
      {rows.length === 0 ? (
        <p className="admin-subs__empty" data-testid="inquiries-empty">No shortlists have been sent yet.</p>
      ) : (
        <ul className="admin-inq">
          {rows.map((r) => (
            <li key={r.id} className="admin-inq__item" data-testid={`inquiry-${r.id}`}>
              <div className="admin-inq__head">
                <div>
                  <strong>{r.name}</strong> · <a href={`mailto:${r.email}`}>{r.email}</a>
                  <span className="mono-caps admin-inq__date">{new Date(r.created_at).toLocaleString()}</span>
                </div>
                <button type="button" className="admin-mini admin-mini--danger mono-caps" onClick={() => remove(r)}>Delete</button>
              </div>
              <ul className="admin-inq__works mono-caps">
                {r.paintings.map((p) => (
                  <li key={p.slug}><a href={`/paintings/${p.slug}`} target="_blank" rel="noreferrer">{p.title}</a>{p.price_display ? ` — ${p.price_display}` : ""}</li>
                ))}
              </ul>
              {r.note && <p className="admin-inq__note">“{r.note}”</p>}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
